export default {
    methods: {
        computeGearRatio(chainring, cog) {
            return (chainring / cog);
        }
    }
}
